module.exports = __webpack_public_path__ + "media/images/icons/icons_small/66_presentBox-545512dff6d89402c79e1171e17b65f0.png";